"use client"

import { ThemeDivider } from "../terra/component/ThemeDivider/ThemeDivider"
import { LayoutCards } from "../terra/layouts/LayoutCards/LayoutCards"
import { documentToHtmlString } from "@contentful/rich-text-html-renderer"
import { INLINES } from "@contentful/rich-text-types"
import { handleButtons } from "@/lib/utils"
import { buildRichTextLinkMaps } from "@/lib/formatters/richTextLinks"
import { processLinkUrl } from "@/lib/formatters/formatLinks"

/** Resolves entry-hyperlink nodes to real hrefs so they don't fall back to
 * the renderer's default `<span>type: entry-hyperlink id: ...</span>` output. */
function cardDescriptionOptions(links: any, lang: string) {
  const { entryHyperlink } = buildRichTextLinkMaps(links)
  return {
    renderNode: {
      [INLINES.ENTRY_HYPERLINK]: (node: any, next: (content: any) => string) => {
        const text = next(node.content)
        const entry = entryHyperlink.get(node?.data?.target?.sys?.id)
        const href = entry && processLinkUrl(entry, lang)
        return href ? `<a href="${href.replace(/"/g, "&quot;")}">${text}</a>` : text
      },
    },
  }
}

/* In MXP Contentful Layout Cards are just Bound */
export default function MXPLayoutCards(props: any) {
  const { value, index, divider, headerElement, isLCP, lang } = props

  const buttons: any[] = handleButtons(value.buttonsCollection?.items, true, lang)
  const cards: any[] = []
  value.cardsCollection?.items?.map((item: any) => {
    if (item) {
      const buttonData = handleButtons([item.link], true, lang)

      cards.push({
        eyebrow: item.eyebrow,
        header: item.header,
        description:
          documentToHtmlString(
            item.description?.json,
            cardDescriptionOptions(item.description?.links, lang),
          ) || "",
        button: buttonData?.[0],
        image: {
          url: item?.image?.image?.url,
          alt: item?.image?.altText,
          focusArea: item?.image?.focusArea,
        },
        // quote: item.quote,
        // attributionName: item.author,
        // attributionQualification: item.qualification,
      })
    }
  })

  /* normal circle unbound block categorized */

  const dividerClasses = `section-divider-wrap ${value.theme}`
  return (
    <>
      <LayoutCards
        key={index}
        eyebrow={value.eyebrow}
        header={value.header}
        subheader={value.subheader}
        description={documentToHtmlString(value?.description?.json)}
        presetTheme={value.theme}
        cards={cards}
        cardType={"bound"}
        buttons={buttons}
        isWrapped={true}
        isHeaderBig={value.isHeaderBig || false}
        isButtonTopAligned={value.buttonPlacement}
        componentImagePriority={value?.componentImagePriority}
        headerElement={headerElement}
        isLCP={isLCP}
      />
      {divider && (
        <div className={dividerClasses}>
          <ThemeDivider currentTheme={value.theme} />
        </div>
      )}
    </>
  )
}
